<template>
  <div>
    <el-button
      type="primary"
      v-if="status == 1 && currentUser.is_stockroom_admin"
      @click.native="batchStockOut"
      v-code="51102"
      >批量出库</el-button
    >
    <div style="float: right" v-if="status == 1 || status == 3">
      <file-button
        obj="drill_inventory"
        :filter="filter"
        :importButton="false"
        exportBtnName="导出"
      ></file-button>
    </div>
    <div style="float: right" v-if="status == 0 && currentUser.id == 1">
      <file-button
        obj="drill_record"
        :exportButton="false"
        style="float: right"
      ></file-button>
    </div>
    <el-table
      :data="items"
      :key="tableKey"
      @selection-change="handleSelectionChange"
    >
      <template v-if="status == 1 && currentUser.is_stockroom_admin">
        <el-table-column type="selection" width="55" :selectable="selectable">
        </el-table-column>
      </template>
      <el-table-column
        label="序列号"
        align="center"
        prop="drill.serial_number"
        min-width="100"
      >
        <template slot-scope="scope">
          <DrillLink :no="scope.row.drill.serial_number"></DrillLink>
          <el-tag
            size="mini"
            effect="plain"
            class="ml-5"
            v-if="status == 0 || status == 1"
            >{{ DrillIsNewMap[scope.row.drill.is_new] }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center">
        <template slot-scope="scope">
          {{ DrillTypeMap[scope.row.drill.drill_type] }}
        </template>
      </el-table-column>
      <el-table-column
        label="型号"
        prop="drill.model_number"
        align="center"
      ></el-table-column>
      <el-table-column
        label="零件号"
        align="center"
        prop="drill.component_number"
      ></el-table-column>
      <el-table-column
        label="规格"
        align="center"
        prop="drill.specification"
      ></el-table-column>
      <el-table-column label="包装" align="center">
        <template slot-scope="scope">
          {{ DrillPackageType[scope.row.drill.package_type] }}
        </template>
      </el-table-column>
      <el-table-column
        label="入库类型"
        align="center"
        v-if="status == 0 || status == 1"
      >
        <template slot-scope="scope">
          {{ DrillStockInCategoryMap[scope.row.stock_in_category] }}
        </template>
      </el-table-column>
      <el-table-column
        label="入库时间"
        align="center"
        v-if="status == 1"
        min-width="120"
      >
        <template slot-scope="scope">
          {{
            scope.row.stock_in_time
              ? $time(scope.row.stock_in_time).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="出库类型" align="center" v-if="status == 3">
        <template slot-scope="scope">
          {{ DrillStockOutCategoryMap[scope.row.stock_out_category] }}
        </template>
      </el-table-column>
      <el-table-column
        label="出库时间"
        align="center"
        v-if="status == 3"
        min-width="120"
      >
        <template slot-scope="scope">
          {{
            scope.row.stock_out_time
              ? $time(scope.row.stock_out_time).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{ DrillStageMap[scope.row.stage] }}
        </template>
      </el-table-column>
      <el-table-column label="仓库" align="center" prop="stockroom.name">
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <template v-if="currentUser.id == scope.row.stockroom.user_id">
            <btn-tag
              :btn="true"
              text="出库"
              :key="Math.random()"
              :auth-id="51102"
              module-name="stock"
              btn-class="btn-warning"
              @click.native="drillStockOut(scope.row, scope.$index)"
              v-if="scope.row.status == 1"
            ></btn-tag>
            <btn-tag
              :btn="true"
              text="退货入库"
              :key="Math.random()"
              :auth-id="51102"
              module-name="stock"
              btn-class="btn-warning"
              @click.native="hanldeReturnStockIn(scope.row, scope.$index)"
              v-if="scope.row.stock_out_category == 4 && scope.row.status == 3"
            ></btn-tag>
            <button
              v-if="status == 3 && scope.row.logistic_number"
              class="btn btn-sm btn-labeled btn-rounded btn-default"
              @click="drillDeliveryDetail(scope.row, scope.$index)"
            >
              物流信息
            </button>

            <btn-tag
              :btn="true"
              text="确认入库"
              :key="Math.random()"
              :auth-id="51102"
              btn-class="btn-warning"
              module-name="stock"
              @click.native="hanldeConfirmStockIn(scope.row, scope.$index)"
              v-if="scope.row.status == 0"
            ></btn-tag>
            <btn-tag
              :btn="true"
              text="编辑"
              :key="Math.random()"
              :auth-id="51102"
              module-name="stock"
              @click.native="editItem(scope.row, scope.$index)"
              v-if="scope.row.status == 0"
            ></btn-tag>

            <!-- <btn-tag
            :href="'/stock/drills/' + scope.row.id"
            text="复合片记录"
            :key="Math.random()"
            :auth-id="51103"
            module-name="stock"
            v-if="scope.row.status != 0"
          ></btn-tag> -->
          </template>
          <template v-else>
            <el-tag effect="plain" type="danger" size="small" v-if="status == 0"
              >待入库</el-tag
            >
            <button
              v-if="status == 3 && scope.row.logistic_number"
              class="btn btn-sm btn-labeled btn-rounded btn-default"
              @click="drillDeliveryDetail(scope.row, scope.$index)"
            >
              物流信息
            </button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <drill-former
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
      :isGeneralStockroom="isGeneralStockroom"
    ></drill-former>
    <drill-out-former
      :model="model"
      :show.sync="formerOutVisible"
      @updated="stockOutCallback"
    ></drill-out-former>

    <!-- <delivery-former
      :model="model"
      :show.sync="formerDeliveryVisible"
      @updated="updatedCallback"
    ></delivery-former> -->

    <delivery-info
      :model="model"
      :show.sync="formerDeliveryVisible"
    ></delivery-info>
  </div>
</template>

<script>
import { itemDelete, drillRecordConfirm } from '@/service/getData'
import {
  DrillStockInCategoryMap,
  DrillStockOutCategoryMap,
  DrillStageMap,
  DrillTypeMap,
  DrillIsNewMap,
  DrillPackageType,
} from '@/config/global'
import DrillFormer from '@/components/drill_in_former'
import DrillOutFormer from '@/components/drill_out_former'
import DeliveryFormer from '@/components/delivery_former'
import DeliveryInfo from '@/components/delivery_info'
import { deepClone } from '@/utils'
import { getStore } from '@/config/mUtils'

export default {
  components: {
    DrillFormer,
    DrillOutFormer,
    DeliveryFormer,
    DeliveryInfo,
  },
  props: {
    items: null,
    status: 0,
    isGeneralStockroom: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      currentUser: getStore('userInfo'),
      DrillStockInCategoryMap,
      DrillStockOutCategoryMap,
      DrillStageMap,
      DrillTypeMap,
      DrillIsNewMap,
      DrillPackageType,
      model: {},
      formerVisible: false,
      formerOutVisible: false,
      formerDeliveryVisible: false,
      editIndex: 0,
      tableKey: Math.random(),
      selectedDrills: [],
    }
  },
  watch: {
    $route: function () {
      this.tableKey = Math.random()
      this.selectedDrills = []
    },
  },
  methods: {
    selectable(e) {
      return e.stockroom.user_id == this.currentUser.id
    },
    handleSelectionChange(val) {
      this.selectedDrills = val.map((item) => {
        return { id: item.id, serial_number: item.drill.serial_number }
      })
    },
    batchStockOut() {
      if (this.selectedDrills.length == 0) {
        this.$alert('请至少选择一条数据')
        return
      }
      this.model = {
        id: 0,
        selected_drills: this.selectedDrills,
        stock_out_category: '',
        stock_out_stockroom_id: '',
      }
      this.editIndex = -1
      this.formerOutVisible = true
    },
    // drillDelivery(item, index) {
    //   this.model = {
    //     subject_id: item.id,
    //     category: 1,
    //     deliver_time: new Date(),
    //   }
    //   this.editIndex = index
    //   this.formerDeliveryVisible = true
    // },
    drillDeliveryDetail(item, index) {
      this.model = item
      this.formerDeliveryVisible = true
    },
    drillStockOut(item, index) {
      this.model = {
        id: item.id,
        stock_out_category: '',
        stock_out_stockroom_id: '',
        logistic_company: '',
        logistic_number: '',
        receiver_mobile: '',
      }
      this.editIndex = index
      this.formerOutVisible = true
    },
    editItem(item, index) {
      let model = deepClone(item)
      model.serial_number = item.drill.serial_number
      model.is_new = item.drill.is_new
      model.drill_type = item.drill.drill_type
      model.model_number = item.drill.model_number
      model.component_number = item.drill.component_number
      model.specification = item.drill.specification
      model.package_type = item.drill.package_type
      model.price = item.drill.price
      this.model = model
      this.editIndex = index
      this.formerVisible = true
    },
    updatedCallback(data) {
      this.$set(this.items, this.editIndex, data)
    },
    stockOutCallback(data) {
      this.$message({
        message: '操作成功！',
        type: 'success',
      })
      if (this.editIndex == -1) {
        this.$emit('stockOut')
      } else {
        this.items.splice(this.editIndex, 1)
      }
    },
    hanldeConfirmStockIn(item, index) {
      let that = this
      this.$confirm('确认入库吗?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let data = { id: item.id }
          let res = await drillRecordConfirm(data)
          if (res.status == 0) {
            this.items.splice(index, 1)
            this.$message({
              message: '操作成功！',
              type: 'success',
            })
          }
        })
        .catch(() => {})
    },
    hanldeReturnStockIn(item, index) {
      this.$prompt('请输入退货原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '退货原因不能为空',
      })
        .then(async ({ value }) => {
          let data = { id: item.id, remark: value }
          let res = await drillRecordConfirm(data)
          if (res.status == 0) {
            this.items.splice(index, 1)
            this.$message({
              message: '操作成功！',
              type: 'success',
            })
          }
        })
        .catch(() => {})
    },
    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        itemDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>